import Helper from './Helper';

class ChartToggler {
  constructor(config = {}) {
    const {
      buttons,
      charts,
      chartContainer
    } = config;
    this.chartString = charts;
    this.buttonString = buttons;
    this.chartContainerString = chartContainer;
    this.buttons = Array.prototype.slice.call(document.querySelectorAll(buttons));
    this.charts = Array.prototype.slice.call(document.querySelectorAll(charts));
    this.chartContainer = Array.prototype.slice.call(document.querySelectorAll(chartContainer));
    if(this.buttons.length !== 0 && this.charts.length !== 0){
      this.bindEvents();
    }
  }

  bindEvents() {
    this.chartContainer.forEach((item, index)=>{
      let chartArray = Array.prototype.slice.call(item.querySelectorAll(this.chartString));
      let buttonArray = Array.prototype.slice.call(item.querySelectorAll(this.buttonString));
      chartArray.forEach((chart, i) => {
        chart.id = `graphic${index}-${i}`;
      });
      buttonArray.forEach((button, i)=> {
        button.setAttribute('data-toggle', `graphic${index}-${i}`);
      });
    });

    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => {
        const activeChart = document.querySelector(`#${button.dataset.toggle}`);
        const activeButton = button;

        this.changeClass(activeButton, this.buttons);
        this.changeClass(activeChart, this.charts);
      });
    });
  }

  changeClass(activeitem) {
    const className = activeitem.classList[0];
    const parent = Helper.getClosest(activeitem, this.chartContainerString);
    const allElementsInParent = Array.prototype.slice.call(parent.querySelectorAll(`.${className}`));
    allElementsInParent.forEach( element => {
      if(element.classList.contains('active') && element !== activeitem){
        Helper.removeClass(element, 'active--animated');
        Helper.removeClass(element, 'active');
      }
    });
    Helper.addClass(activeitem, 'active');
    setTimeout(() => {
      Helper.addClass(activeitem, 'active--animated');
    }, 200);
  }
}

export default ChartToggler;
